import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html'
})
export class ConfirmationDialog implements OnInit {
  @Input() confirmDialog: boolean = false;
  @Input() confirmationText: string = "Do you want to proceed?";
  @Output() shouldConfirm: EventEmitter<boolean> = new EventEmitter<boolean>(); 

  constructor() { }

  ngOnInit(): void {
  }

  confirmResponse(response: boolean) {
    this.confirmDialog = false;
    this.shouldConfirm.emit(response);
  }
}
